/**
 * Where a tab goes when it loses its session — an explicit sign-out, an expired session, an
 * idle timeout, or a 401 from any request. It carries the page it was on, so signing back in
 * returns it there rather than to a shared landing page, and two tabs come back to two places.
 *
 * The auth host validates the value against its own allowlist, so an unusable one is refused
 * there rather than trusted here.
 *
 * The page is a parameter rather than a window read so a test can name it: window.location is
 * read-only in jsdom, and the rule is the half worth pinning.
 */
export function buildSignOutTarget(redirectUrl: string, currentUrl?: string): string {
  let page = '';
  if (currentUrl !== undefined) {
    page = currentUrl;
  } else if (typeof window !== 'undefined') {
    page = window.location.href;
  }
  if (page.length === 0 || redirectUrl.includes('continue=')) {
    return redirectUrl;
  }
  const separator = redirectUrl.includes('?') ? '&' : '?';
  return `${redirectUrl}${separator}continue=${encodeURIComponent(page)}`;
}
